import profileAsset from "@/assets/icons/recognition/permanent-professional-profile.webp";
import badgesAsset from "@/assets/icons/recognition/recognition-badges.webp";
import shareableAsset from "@/assets/icons/recognition/shareable-digital-assets.webp";
import visibilityAsset from "@/assets/icons/recognition/voting-visibility.webp";
import milestonesAsset from "@/assets/icons/recognition/recognition-milestones.webp";
import awardAsset from "@/assets/icons/recognition/award-display-options.webp";

export type RecognitionIconKey =
  | "profile"
  | "badges"
  | "shareable"
  | "visibility"
  | "milestones"
  | "award";

const MAP: Record<RecognitionIconKey, string> = {
  profile: profileAsset,
  badges: badgesAsset,
  shareable: shareableAsset,
  visibility: visibilityAsset,
  milestones: milestonesAsset,
  award: awardAsset,
};

export function RecognitionFeatureIcon({
  name,
  className = "h-8 w-8",
}: {
  name: RecognitionIconKey;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={`inline-flex shrink-0 items-center justify-center ${className}`}
    >
      <img
        src={MAP[name]}
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        className="h-full w-full object-contain"
      />
    </span>
  );
}
